var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mockData as documentEventsData } from '@web/lib/demo/data/documentEvents';
export var documents = function (input) {
    var documents = documentEventsData
        .reduce(function (acc, item) {
        if (!acc.find(function (doc) { return doc.id === item.document.id; }))
            return acc;
        acc.push(__assign(__assign({}, item.document), { createdAt: new Date(item.document.createdAt), updatedAt: new Date(item.document.updatedAt), ownerId: null }));
        return acc;
    }, [])
        .slice(0, input.limit);
    return documents.map(function (document) { return (__assign(__assign({}, document), { createdAt: document.createdAt.toISOString(), updatedAt: document.updatedAt.toISOString() })); });
};
